import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
// import Loadable from 'react-loadable';

// import reducerRegistry from 'reducerRegistry';
// import epicsRegistry from 'epicsRegistry';
import NotFound from 'NotFound';
import LandingPageView from 'modules/LandingPageView';
import Contact from 'modules/Contact';
import Legal from 'modules/Legal';
// import { LoadingSpinner } from 'components/Loading';

class HomeRouterView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Switch>
        <Route key="contactPage" path="/legal" component={Legal} />
        <Route key="contactPage" path="/privacy" component={Legal} />
        {/* <Route key="contactPage" path="/contact" component={Contact} /> */}
        <Route key="landingPage" path="/" component={LandingPageView} {...this.props} />
        <Route component={NotFound} />
      </Switch>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

const HomeRouter = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeRouterView);

export default HomeRouter;
